import Ajax from '../util/ajax';
export function zigbeeOff(node_id, endpoint_id) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        ajax.throttle_post('/zigbee/' + node_id + '/ep/' + endpoint_id + '/off');
    };
}
